import Switch from '@eduzz/houston-ui/Forms/Switch';
import { Grid, FormHelperText, FormControlLabel, TextField, MenuItem, Select, InputLabel, Tooltip, FormControl, Radio } from '@material-ui/core';
import type { StyledComponentProps } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import User from 'classes/User';
import CustomMaskedInput from 'components/MaskedInput';
import { constants } from 'helpers/constants';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import BlockedFieldTooltipProps from 'scenes/Producer/Product/EditProduct/components/General/blockedTooltipProps';
import { recurrencyFrequencyType } from 'scenes/Producer/Product/EditProduct/components/Sales/components/Subscription';
import styles from 'scenes/Producer/Product/NewProduct/components/Forms/styles';
import { EChargeType, EProductType } from 'v2/interfaces/product';
import { run } from 'validations/ruleRunner';

import PermanentAccessAlertModal from './PermanentAccessAlertModal';
import Validations from './validations';

import type IProduct from 'interfaces/IProduct';

interface IProps extends StyledComponentProps {
  product: IProduct;
  loggedUser: any;
  enabledValidation: boolean;
  handleChange: any;
  currencyList: any;
  setRefField: any;
  setRefError: any;
  isAlumy?: boolean;
}

interface IStates {
  showErrors: boolean;
  validationErrors: any;
  showPermanentAccessAlertModal: boolean;
}

const CUSTOM_RECURRENCY = 'P';

class Subscription extends Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      showErrors: false,
      validationErrors: [],
      showPermanentAccessAlertModal: false,
    };
  }

  getPriceHelperText = () => {
    if (this.isValid('recurring_value')) return this.errorFor('recurring_value');
    const isInfo = this.props.product.type === EProductType.DIGITAL;
    const isSinglePayment = this.props.product.charge_type === EChargeType.SINGLE;
    if (isInfo && isSinglePayment) return 'Você poderá cadastrar o preço de venda inclusive para moedas estrangeiras na Edição';
    return 'EX: 1.000,00';
  };

  errorFor = (field: any) => {
    return this.state.validationErrors[field] || '';
  };

  isValid = (field: any) => {
    return this.state.validationErrors[field] ? true : false;
  };

  handleChangeAfterRadio = () => {
    this.props.handleChange('undetermined_charges', false);
    this.props.handleChange('limit_charges', this.props.product.limit_charges);
  };

  handleChangeRecurrencyType = (value: string) => {
    this.props.handleChange('recurring_frequency_type', value);
    if (value === CUSTOM_RECURRENCY) {
      this.props.handleChange('recurring_frequency', 2);
      this.props.handleChange('recurring_frequency_type_select', 'MONTH');
      return;
    }
    this.props.handleChange('recurring_frequency', 1);
  };

  componentDidUpdate(prevProps: IProps) {
    const { product } = this.props;
    if ((prevProps.enabledValidation === false && this.props.enabledValidation) || product !== prevProps.product) {
      let newState = { ...this.state };
      newState.validationErrors = run(product, Validations);
      this.setState(newState);
    }
  }

  handleChangePermanentAccess = (permanentAccess: boolean) => {
    if (permanentAccess) {
      this.setState({ showPermanentAccessAlertModal: true });
    }
    this.props.handleChange('permanent_access', permanentAccess);
  };

  handleClosePermanentAccessModal = () => {
    this.setState({ showPermanentAccessAlertModal: false });
  };

  render() {
    const { handleChange, product, setRefField, isAlumy, classes } = this.props;

    return (
      <>
        <Grid item xs={12} sm='auto' style={{ alignSelf: 'baseline' }}>
          <div className={classes.brlCurrencyContainer}>
            <InputLabel>Moeda</InputLabel>
            <Typography variant='body1'>BRL (Real Brasileiro)</Typography>
          </div>
        </Grid>
        <Grid className={classes.priceContainer} item xs={12} sm='auto'>
          <CustomMaskedInput
            label='Preço'
            fullWidth={true}
            disableUnderline={true}
            id='new-product-subscription-value'
            mask='money'
            value={product.recurring_value}
            onChange={(value: any) => handleChange('recurring_value', value)}
            helperText={this.getPriceHelperText()}
            error={this.isValid('recurring_value')}
            InputLabelProps={{
              shrink: true,
            }}
            startAdornment='R$'
            ref={(ref: any) => setRefField('recurring_value', ref)}
          />
        </Grid>
        <Grid item xs={12}>
          <BlockedFieldTooltipProps partnerCod={product.cnt_partner_cod} enabled={isAlumy}>
            <TextField
              label='Frequência de cobrança'
              id='new-product-subscription-frequency-type'
              select
              fullWidth
              value={product.recurring_frequency_type}
              onChange={(e: any) => this.handleChangeRecurrencyType(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                disableUnderline: true,
              }}
            >
              {Object.keys(recurrencyFrequencyType).map((type) => (
                <MenuItem key={type} value={recurrencyFrequencyType[type].abbr}>
                  {type}
                </MenuItem>
              ))}
            </TextField>
          </BlockedFieldTooltipProps>
        </Grid>
        {product.recurring_frequency_type === CUSTOM_RECURRENCY && (
          <Grid item xs={12}>
            <BlockedFieldTooltipProps partnerCod={product.cnt_partner_cod} enabled={isAlumy}>
              <>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                  <p>Repetir a cada:</p>
                  <div style={{ width: '50px', margin: '0 10px', display: 'flex' }}>
                    <CustomMaskedInput
                      id='new-product-subscription-frequency'
                      error={this.isValid('recurring_frequency')}
                      mask='number'
                      disableUnderline={true}
                      value={product.recurring_frequency}
                      onChange={(value: any) => handleChange('recurring_frequency', value)}
                      disabled={isAlumy}
                    />
                  </div>
                  <FormControl>
                    <Select
                      onChange={(e) => handleChange('recurring_frequency_type_select', e.target.value)}
                      value={product.recurring_frequency_type_select}
                    >
                      <MenuItem value='MONTH'>{product.recurring_frequency > 1 ? 'meses' : 'mês'}</MenuItem>
                      <MenuItem value='YEAR'>{product.recurring_frequency > 1 ? 'anos' : 'ano'}</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                {this.isValid('recurring_frequency') && <FormHelperText error>{this.errorFor('recurring_frequency')}</FormHelperText>}
              </>
            </BlockedFieldTooltipProps>
          </Grid>
        )}
        <Grid item xs={12}>
          <BlockedFieldTooltipProps partnerCod={product.cnt_partner_cod} enabled={isAlumy}>
            <>
              <div>A cobrança termina em:</div>
              <div>
                <FormControlLabel
                  control={<Radio color='primary' />}
                  label='Nunca'
                  checked={product.undetermined_charges}
                  onChange={(_, checked) => {
                    if (checked) {
                      handleChange('limit_charges', '2');
                    }
                    handleChange('undetermined_charges', checked);
                  }}
                />
                <div>
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 8 }}>
                    <FormControlLabel
                      style={{ marginRight: 0 }}
                      control={<Radio color='primary' />}
                      label='Após'
                      checked={!product.undetermined_charges}
                      onChange={this.handleChangeAfterRadio}
                    />
                    <div style={{ width: 57 }}>
                      <CustomMaskedInput
                        id='new-product-subscription-limit-charges'
                        mask='number'
                        error={this.isValid('limit_charges')}
                        onChange={(value: string) => {
                          if (value.length > 2) return;
                          handleChange('limit_charges', value);
                        }}
                        value={product.limit_charges}
                        disabled={isAlumy || product.undetermined_charges}
                      />
                    </div>
                    <span>{product.limit_charges > 1 ? 'cobranças' : 'cobrança'}</span>
                  </div>
                  {this.isValid('limit_charges') && <FormHelperText error>{this.errorFor('limit_charges')}</FormHelperText>}
                </div>
              </div>
            </>
          </BlockedFieldTooltipProps>
        </Grid>
        <Grid item xs={12}>
          <Tooltip
            disableFocusListener={!(product.type === constants.PHYSICAL)}
            disableHoverListener={!(product.type === constants.PHYSICAL)}
            disableTouchListener={!(product.type === constants.PHYSICAL)}
            title={product.type === constants.PHYSICAL ? 'A Adesão não pode ser habilitado em produtos físicos' : ''}
            placement='bottom'
          >
            <div>
              <Switch
                id='new-product-subscription-fee'
                disabled={product.trial || product.yearly_installment || product.type === constants.PHYSICAL}
                value={product.membership_fee}
                onChange={(bool: boolean) => handleChange('membership_fee', bool)}
              >
                Taxa de contratação / adesão
              </Switch>
              <FormHelperText>O cliente deve pagar taxa de contratação.</FormHelperText>
            </div>
          </Tooltip>
        </Grid>
        {!!product.membership_fee && (
          <Grid item xs={12}>
            <CustomMaskedInput
              label='Valor de adesão'
              id='new-product-subscription-membership-price'
              mask='money'
              value={product.membership_price}
              onChange={(value: any) => handleChange('membership_price', value)}
              fullWidth={true}
              error={this.isValid('membership_price')}
              helperText={this.isValid('membership_price') ? this.errorFor('membership_price') : 'Ex: R$ 20,00'}
              disableUnderline={true}
              InputLabelProps={{
                shrink: true,
              }}
              ref={(ref: any) => setRefField('membership_price', ref)}
            />
          </Grid>
        )}
        <Grid item xs={12}>
          <Tooltip
            disableFocusListener={!(product.membership_fee || product.yearly_installment || product.type === constants.PHYSICAL)}
            disableHoverListener={!(product.membership_fee || product.yearly_installment || product.type === constants.PHYSICAL)}
            disableTouchListener={!(product.membership_fee || product.yearly_installment || product.type === constants.PHYSICAL)}
            title={
              product.membership_fee
                ? 'O Trial não pode ser habilitado junto com a Adesão'
                : product.yearly_installment
                ? 'O Trial não pode ser habilitado junto com o Parcelamento da Recorrência'
                : product.type === constants.PHYSICAL
                ? 'O Trial não pode ser habilitado em produtos físicos'
                : ''
            }
            placement='bottom'
          >
            <div>
              <Switch
                id='new-product-subscription-trial'
                disabled={product.membership_fee || product.yearly_installment || product.type === constants.PHYSICAL}
                value={product.trial}
                onChange={(bool: boolean) => handleChange('trial', bool)}
              >
                Período trial
              </Switch>
              <FormHelperText>Permitir que o cliente experimente o produto.</FormHelperText>
            </div>
          </Tooltip>
        </Grid>
        {product.trial && (
          <Grid item xs={12}>
            <div>
              <CustomMaskedInput
                label='Dias para trial'
                id='new-product-subscription-trial-days'
                mask='number'
                error={this.isValid('trial_days')}
                value={product.trial_days}
                onChange={(value: any) => handleChange('trial_days', value)}
                fullWidth={true}
                disableUnderline={true}
              />
              <FormHelperText>{this.isValid('trial_days') ? this.errorFor('trial_days') : 'Ex: 15 dias'}</FormHelperText>
            </div>
          </Grid>
        )}
        {!product.undetermined_charges && (
          <Grid item xs={12}>
            <div>
              <Switch
                id='new-product-subscriptionpermanent-access'
                value={product.permanent_access}
                onChange={(checked: boolean) => this.handleChangePermanentAccess(checked)}
              >
                Acesso permanente
              </Switch>
            </div>
            <FormHelperText>Mantém o acesso mesmo após o término das cobranças.</FormHelperText>
          </Grid>
        )}
        <Grid item xs={12}>
          <div>
            <CustomMaskedInput
              label='Limite de atraso'
              id='new-product-subscription-overdue-limit'
              mask='number'
              fullWidth={true}
              error={this.isValid('overdue_limit')}
              helperText={
                this.isValid('overdue_limit')
                  ? this.errorFor('overdue_limit')
                  : `Após ${product.overdue_limit} cobrança(s) consecutivas em atraso, a assinatura será cancelada automaticamente.`
              }
              disableUnderline={true}
              value={product.overdue_limit}
              onChange={(value: any) => handleChange('overdue_limit', value)}
              InputLabelProps={{
                shrink: true,
              }}
              ref={(ref: any) => setRefField('overdue_limit', ref)}
            />
          </div>
        </Grid>
        <PermanentAccessAlertModal isOpen={this.state.showPermanentAccessAlertModal} handleClose={() => this.handleClosePermanentAccessModal()} />
      </>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    loggedUser: new User(state.orbita.User.user),
  };
}

export default connect(mapStateToProps)(styles(Subscription));
